import { LoaderCircleIcon } from "@talladega/icons";
import classNames from "classnames";

type Size = "sm" | "md" | "lg";

type Props = {
  className?: string;
  size?: Size;
};

const LoadingCircle = ({ className, size = "lg" }: Props) => {
  const classSize = {
    "size-12": size === "lg",
    "size-8": size === "md",
    "size-4": size === "sm",
  };

  return (
    <div className={classNames("relative", classSize)}>
      <div className="absolute inset-0 rotate-180">
        <LoaderCircleIcon
          className={classNames(
            "animate-spin",
            className,
            "text-foreground opacity-20",
            classSize
          )}
        />
      </div>
      <LoaderCircleIcon
        className={classNames("relative animate-spin", className, classSize)}
      />
    </div>
  );
};

export default LoadingCircle;
